"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoSyncContext = void 0;
var react_1 = __importStar(require("react"));
var CognitoSyncManager_1 = __importDefault(require("./models/CognitoSyncManager"));
var aws_amplify_1 = require("aws-amplify");
var _1 = require(".");
function CognitoSyncContextProvider(_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(), client = _b[0], setClient = _b[1];
    var token = (0, _1.useToken)();
    (0, react_1.useEffect)(function () {
        if (token) {
            aws_amplify_1.Auth.currentCredentials().then(function (cred) {
                setClient(new CognitoSyncManager_1.default(cred));
            });
        }
    }, [token]);
    return (react_1.default.createElement(exports.CognitoSyncContext.Provider, { value: { client: client } }, children));
}
exports.default = CognitoSyncContextProvider;
exports.CognitoSyncContext = react_1.default.createContext({
    client: undefined,
});
//# sourceMappingURL=CognitoSyncContextProvider.js.map